(function () {
  var STORAGE_KEY = 'um_cookie_consent';

  function getConsent() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) { return null; }
  }

  function setConsent(consent) {
    consent.timestamp = new Date().toISOString();
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(consent)); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('um:consent-updated', { detail: consent })); } catch (e) {}
  }

  document.addEventListener('DOMContentLoaded', function () {
    var banner = document.getElementById('CookieBanner');
    if (!banner) return;
    var settings = document.getElementById('CookieSettings');
    var existing = getConsent();

    if (!existing) {
      banner.hidden = false;
    } else {
      try { document.dispatchEvent(new CustomEvent('um:consent-updated', { detail: existing })); } catch (e) {}
    }

    var acceptBtn = banner.querySelector('[data-cookie-accept]');
    var refuseBtn = banner.querySelector('[data-cookie-refuse]');
    var settingsBtn = banner.querySelector('[data-cookie-settings]');
    var saveBtn = banner.querySelector('[data-cookie-save]');

    if (acceptBtn) acceptBtn.addEventListener('click', function () {
      var an = banner.querySelector('[data-cookie-cat="analytics"]');
      var ma = banner.querySelector('[data-cookie-cat="marketing"]');
      if (an) an.checked = true;
      if (ma) ma.checked = true;
      setConsent({ essential: true, analytics: true, marketing: true });
      banner.hidden = true;
    });
    if (refuseBtn) refuseBtn.addEventListener('click', function () {
      setConsent({ essential: true, analytics: false, marketing: false });
      banner.hidden = true;
    });
    if (settingsBtn) settingsBtn.addEventListener('click', function () {
      settings.hidden = !settings.hidden;
    });
    if (saveBtn) saveBtn.addEventListener('click', function () {
      var an = banner.querySelector('[data-cookie-cat="analytics"]');
      var ma = banner.querySelector('[data-cookie-cat="marketing"]');
      setConsent({ essential: true, analytics: an ? an.checked : false, marketing: ma ? ma.checked : false });
      banner.hidden = true;
    });

    document.addEventListener('click', function (e) {
      var reopen = e.target.closest && e.target.closest('[data-cookie-reopen]');
      if (!reopen) return;
      e.preventDefault();
      banner.hidden = false;
      if (settings) settings.hidden = false;
      var existingNow = getConsent();
      if (existingNow) {
        var an = banner.querySelector('[data-cookie-cat="analytics"]');
        var ma = banner.querySelector('[data-cookie-cat="marketing"]');
        if (an) an.checked = !!existingNow.analytics;
        if (ma) ma.checked = !!existingNow.marketing;
      }
    });
  });
})();
